import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex lg:flex-wrap lg:flex-row flex-col lg:items-center min-h-screen lg:justify-between" }
const _hoisted_2 = { class: "w-full px-4 lg:w-1/2 sm:px-20 lg:py-0 py-6" }
const _hoisted_3 = { class: "sm:max-w-[360px] mx-auto" }
const _hoisted_4 = { class: "" }
const _hoisted_5 = { class: "mb-6" }
const _hoisted_6 = { class: "mb-6" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "mt-6 text-center" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "/login",
    class: "m-0 text-sm transition text-primary-600 hover:text-primary-800"
  }, "Return to Login")
], -1)

import { ref, onMounted } from 'vue';
import {
    IonPage,
    IonContent 
} from '@ionic/vue';
import ButtonComponent from '@/components/buttons/ButtonComponent.vue';
import PasswordInput from '@/components/inputs/PasswordInput.vue';
import ConfirmationModal from '@/components/modals/ConfirmationModal.vue';

import { useRoute, useRouter } from 'vue-router';

import PageLoader from "@/components/loaders/PageLoader.vue"
import SuccessModal from '@/components/modals/SuccessModal.vue';

import ForgotPassword from '@/classes/ForgotPassword';

import { errorResponse } from "@/helpers/errorMessage";

import AuthLogo from "../Components/AuthLogo.vue";
import AuthTitle from "../Components/AuthTitle.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ResetPassword',
  setup(__props) {

const router = useRouter();
const route = useRoute();


const loading = ref<boolean>(false);
const showSuccess = ref<boolean>(false);
const successMessage = ref<string>('');
const errors = ref<any>();

const form = ref<{
    email: string
    token: string
    password: string | null
    password_confirmation: string | null
}>({
    email: route.query.email,
    token: route.query.token,
    password: null,
    password_confirmation: null,
})

const submit = (): void => {
    loading.value = true;

    ForgotPassword.setPassword(form.value)
        .then(({ data }) => {
            console.log(data);
            loading.value = false;
            showSuccess.value = true;

        }).catch((error) => {
            loading.value = false;
            errors.value = errorResponse(error.response?.data?.errors)
        });

}
    
const confirm = (): void => {
    router.replace({ path: '/login' });
}


onMounted(() => {
    if (typeof route.query.email == 'undefined' && typeof route.query.token == 'undefined') {
        router.replace({ path: '/login' })
    }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonContent), { fullscreen: true }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(AuthLogo),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(AuthTitle, {
                  title: "New Password",
                  description: "Kindly provide your new password"
                }),
                _createElementVNode("form", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(PasswordInput, {
                      label: "New Password",
                      placeholder: "New Password",
                      name: "new-password",
                      id: "new-password",
                      modelValue: form.value.password,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.password) = $event)),
                      error: errors.value?.password
                    }, null, 8, ["modelValue", "error"])
                  ]),
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(PasswordInput, {
                      label: "Confirm Password",
                      placeholder: "Confirm Password",
                      name: "confirm-password",
                      id: "confirm-password",
                      modelValue: form.value.password_confirmation,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.password_confirmation) = $event)),
                      error: errors.value?.password_confirmation
                    }, null, 8, ["modelValue", "error"])
                  ]),
                  _createVNode(ButtonComponent, {
                    type: "button",
                    size: "large",
                    btnWidth: "w-full rounded-lg",
                    onClick: submit
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Reset Password ")
                    ]),
                    _: 1
                  }),
                  _hoisted_7
                ])
              ])
            ])
          ]),
          _createVNode(SuccessModal, {
            show: showSuccess.value,
            onConfirm: confirm,
            "action-text": "Confirm",
            title: "Password Updated!",
            content: "Your password has been successfully updated"
          }, null, 8, ["show"]),
          _createVNode(PageLoader, { show: loading.value }, null, 8, ["show"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})